
// => Styling
import styles from './Controls.module.css';

// => Icons
import {
    IoPause,
    IoPlay,
    IoContract,
    IoExpand,
    IoEye,
    IoEyeOff,
} from "react-icons/io5";

// => Components
import IconButton from '../../../components/IconButton';


// ============
// Component
// ============
const Controls = ({
    gamePaused = false,
    onRequestPause = () => {},
    fullscreen = false,
    onRequestFullscreen = () => {},
    overlayEnabled = true,
    onRequestOverlayToggle = () => {},
}) => {


    function togglePause() {
        onRequestPause()
    }

    function toggleOverlay() {
        onRequestOverlayToggle()
    }

    function toggleFullscreen() {
        onRequestFullscreen()
    }


    // RENDER
    // ---------
    return(
        <div className={[styles.container, gamePaused ? styles.containerPaused : null].join(" ")}>
            
            <IconButton id="control_pause"
                        icon={gamePaused ? <IoPlay /> : <IoPause />}
                        tooltip={<span>{gamePaused ? "Resume" : "Pause"} Game</span>}
                        onClick={()=>togglePause()} />

            <IconButton id="control_overlay"
                        icon={overlayEnabled ? <IoEyeOff /> : <IoEye />}
                        tooltip={<span>{overlayEnabled ? "Disable" : "Enable"} OverlayFX</span>}
                        onClick={()=>toggleOverlay()} />
                        
            <IconButton id="control_fullscr"
                        icon={fullscreen ? <IoContract /> : <IoExpand />}
                        tooltip={<span>{fullscreen ? "Exit" : "Enter"} Fullscreen</span>}
                        onClick={()=>toggleFullscreen()} />

        </div>
    )
}


export default Controls